import { createEntityAdapter } from "@reduxjs/toolkit";
import { StorageObjectValue } from "../../../services/api/instances/storageApi/types/service_types";
import { NormalizedStorageObject } from "../../../services/api/instances/storageApi/types/object_types";

export const storageObjectAdapter =
  createEntityAdapter<NormalizedStorageObject<StorageObjectValue>>();
